import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
  selector: "[appPreventDoubleClick]",
})
export class PreventDoubleClickDirective {
  disabledTime = 500;

  constructor(private elementRef: ElementRef) {}

  @HostListener("click", ["$event"])
  clickEvent() {
    this.elementRef.nativeElement.setAttribute("disabled", "true");
    setTimeout(
      () => this.elementRef?.nativeElement?.removeAttribute("disabled"),
      this.disabledTime,
    );
  }
}
